
import { GameState } from '../GameContextTypes';

export const setSimulationComplete = (state: GameState, value: boolean): GameState => {
  return {
    ...state,
    isSimulationComplete: value
  };
};
